import React from 'react';
// Images
import ClipsImage from '../../assets/images/small/mistress-sammi-smith-trans-dominatrix-and-friend-playing-with-happy-sub-small.jpg';
import QuestionImage from '../../assets/images/small/mistress-sammi-smith-trans-dominatrix-on-sofa-with-whip-small.jpg';
import ContactImage from '../../assets/images/small/mistress-sammi-smith-trans-dominatrix-main-image-small.jpg';

import {
  QUESTIONNAIRE_PAGE_URL,
  CONTACT_PAGE_URL,
  CLIPS_FANSITES_PAGE_URL,
} from '../../utils/Routes';
import { Link } from 'react-router-dom';

const items = [
  {
    id: 1,
    title: 'Clips & Fansites',
    subtitle: 'Explore exclusive clips, fansite content, and sensual poses.',
    image: ClipsImage,
    link: CLIPS_FANSITES_PAGE_URL,
    ariaLabel:
      'View exclusive clips and fansite content from Mistress Sammi Smith',
  },
  {
    id: 2,
    title: 'Questionnaire',
    subtitle: 'Tell me your deepest desires and let’s make them a reality.',
    image: QuestionImage,
    link: QUESTIONNAIRE_PAGE_URL,
    ariaLabel:
      'Fill out a questionnaire to share your fantasies with Mistress Sammi Smith',
  },
  {
    id: 3,
    title: 'Contact Me',
    subtitle: 'Reach out for bookings, questions, or personal requests.',
    image: ContactImage,
    link: CONTACT_PAGE_URL,
    ariaLabel: 'Contact Mistress Sammi Smith for bookings and inquiries',
  },
];

function PlaySectionTwo() {
  return (
    <section className='container mx-auto px-6 mt-6 lg:px-4'>
      <section className='mb-6 lg:mb-8'>
        <div className='angled_bg lg:w-1/2 pl-8 py-1 rounded-lg'>
          <h2 className='text-3xl lg:text-4xl xl:text-5xl font-titleFont text-center md:text-left md:px-4'>
            Explore More of Me
          </h2>
        </div>
      </section>

      <section className='grid lg:grid-cols-3 gap-8 lg:gap-8'>
        {items.map((item) => (
          <Link
            to={item.link}
            key={item.id}
            className='border-b-2 grid grid-rows-rev pb-4 border-solid border-colour4'
            aria-label={item.ariaLabel}
          >
            <img
              src={item.image}
              alt={`Preview of ${item.title} - ${item.subtitle}`}
              className='w-full h-full object-cover shadow-cardShadowBold shadow-colour4 max-h-[70vh] rounded'
              loading='lazy'
            />
            <div className='h-fit'>
              <h3 className='text-colour1 text-2xl lg:text-3xl font-titleFont mt-2 lg:mt-4 font-semibold'>
                {item.title}
              </h3>
              <p className='play-subtitle'>{item.subtitle}</p>
            </div>
          </Link>
        ))}
      </section>
    </section>
  );
}

export default PlaySectionTwo;
